import DoubleButtonsWeb from "./web";
import { DoubleButtonsBlockProps } from "./types";

export function DoubleButtonsWebEditor(props: DoubleButtonsBlockProps) {
  return <DoubleButtonsWeb {...props} isEditor />;
}
